import { configureStore, } from "@reduxjs/toolkit";

// reducers importing
import appReducer from "./reducer/_index"

export default configureStore({
  reducer: {
    appReducer: appReducer
  },
})
